/*
 * Copyright (C) 2020 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {sample} from 'lodash'
import generateConfettiObject from './generateConfettiObject'

const confettiFlavors = [
  'balloon',
  'bifrost_trophy',
  'butterfly',
  'einstein_rosen_trophy',
  'fire',
  'flowers',
  'four_leaf_clover',
  'gift',
  'gnome',
  'helix_rocket',
  'horse_shoe',
  'hot_air_balloon',
  'magic_mystery_thumbs_up',
  'medal',
  'moon',
  'ninja',
  'panama_rocket',
  'panda',
  'panda_unicycle',
  'pinwheel',
  'pizza_slice',
  'rocket',
  'star',
  'thumbs_up',
  'trophy'
]

/**
 * Returns a random element to be added to the confetti. New assets
 * should be added to the celebrations directory, then added to the list of
 * potential flavors.
 */
export default function getRandomConfettiFlavor() {
  try {
    return generateConfettiObject(sample(confettiFlavors))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e.stack)
    return null
  }
}
